import { SingleRowAction } from '@galaxy/crm/static';
import { AutomationActionsService } from './automation-actions.service';
import { MultiRowAction } from '../../../../static/src';

export function AutomationSingleRowAction(
  namespace: string,
  service: AutomationActionsService,
  objectType: string,
  label: string,
): SingleRowAction {
  return {
    label: label,
    callback: (row) => {
      service.openStartManualAutomationDialog(namespace, objectType, [row]);
    },
  };
}

export function AutomationMultiRowAction(
  namespace: string,
  service: AutomationActionsService,
  objectType: string,
  label: string,
): MultiRowAction {
  return {
    label: label,
    callback: (rows) => {
      service.openStartManualAutomationDialog(namespace, objectType, rows);
    },
  };
}
